import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import ConsultantList from '@/pages/consultants/ConsultantList';
import AddConsultant from '@/pages/consultants/AddConsultant';
import EditConsultant from '@/pages/consultants/EditConsultant';
import PayConsultant from '@/pages/consultants/PayConsultant';
import ConsultantLedger from '@/pages/consultants/ConsultantLedger';
import BusinessReport from '@/pages/consultants/BusinessReport';
import ConsultantCommissions from '@/pages/consultants/ConsultantCommissions';
import PaymentReport from '@/pages/consultants/PaymentReport';
import DuePayment from '@/pages/consultants/DuePayment';
import BlockConsultant from '@/pages/consultants/BlockConsultant';
import StudentPayoutReport from '@/pages/consultants/StudentPayoutReport';

export const consultantRoutes = (
  <React.Fragment>
    <Route path="consultants" element={<Navigate to="consultants/list" replace />} />
    <Route path="consultants/list" element={<ConsultantList />} />
    <Route path="consultants/add" element={<AddConsultant />} />
    <Route path="consultants/edit/:id" element={<EditConsultant />} />
    <Route path="consultants/pay" element={<PayConsultant />} />
    <Route path="consultants/ledger" element={<ConsultantLedger />} />
    <Route path="consultants/business-report" element={<BusinessReport />} />
    <Route path="consultants/commissions" element={<ConsultantCommissions />} />
    <Route path="consultants/payment-report" element={<PaymentReport />} />
    <Route path="consultants/due-payment" element={<DuePayment />} />
    <Route path="consultants/block" element={<BlockConsultant />} />
    <Route path="consultants/student-payout-report" element={<StudentPayoutReport />} />
  </React.Fragment>
);
